import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var ConditionalOperator;
(function (ConditionalOperator) {
    let Type;
    (function (Type) {
        Type[Type["IF_THEN"] = 0] = "IF_THEN";
        Type[Type["IF_THEN_ELSE"] = 1] = "IF_THEN_ELSE";
    })(Type = ConditionalOperator.Type || (ConditionalOperator.Type = {}));
    ConditionalOperator.get = createAccessors(arrayGetSet('conditional_operators'), {
        type: 0,
        comparator_id: -1,
        statementThen: [],
        statementElse: [],
    });
})(ConditionalOperator || (ConditionalOperator = {}));
